module.exports = require("npm:punycode@1.3.2/punycode.js");